import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { getNotifyMessages } from "./helpers";
import { useConfig } from "src/hooks/config";
import selectionsStore from "src/stores/selections";
import betBuilderStore from "src/stores/betBuilder";
import mainStore from "src/stores/main";
import upperDataStore from "src/stores/upperData";
import NotifyMessageItem from "./messageItem";

const NotifyMessages = () => {
	const config = useConfig();
	const { selections } = useRecoilValue(selectionsStore);
	const [mainState] = useRecoilState(mainStore);
	const upperDataState = useRecoilValue(upperDataStore);
	const bbState = useRecoilValue(betBuilderStore);

	return (
		<div className="B-betslip-notify-messages">
			{getNotifyMessages(config).map(data => (
				<NotifyMessageItem
					key={data.id}
					type={data.type}
					message={data.message(config, selections, mainState, upperDataState, bbState)}
					debounce={data.debounce}
				/>
			))}
		</div>
	);
};

export default NotifyMessages;
